import { ApyCard } from "./ApyCard";
import { DepositCard } from "./DepositCard";
import { EarnCard } from "./EarnCard";
import { Social } from "./Social";
import { ReferralCard } from "./ReferralCard";


export const Main = () => { 
    
    
    return(
    <div>
           <Social/>
           <ApyCard />
           <DepositCard />
           <EarnCard />
           <ReferralCard />
    </div>
    );
}